// extracted by mini-css-extract-plugin
export var animating = "_1g-3";
export var background = "_1g-6";
export var constrainHeight = "_1g-2";
export var dark = "_1g-4";
export var dropdown = "_1g-1";
export var leave = "_1g-5";
export var option = "_1g-7";
export var root = "_1g-0";